const PrintType = {
    OrderList: 'OrderList',
    KitchenDocket: 'KitchenDocket',
    DishCategory: 'DishCategory',
    Bill: 'Bill',
    Invoice: 'Invoice',
  };


  // create enum for orderTypes
const OrderType = {
    DineIn: 'DineIn',
    TakeAway: 'TakeAway',
    Delivery: 'Delivery',
    DeliveryPartner: 'DeliveryPartner',
    Foodcourt: 'Foodcourt',
  };

  const L10n = {
    settingsDisplayModeName: "Print name",
    settingsDisplayModeAltname: "Print alternative name",
    settingsDisplayModeShortName: "Print short name",
    settingsDisplayModeBoth: "Print both name and alternative name"
};

const OBNameDisplayMode = {
    showName: "Show name",
    showAlternativeName: "Show alternative name",
    showShortName: "Show short name",
    showBoth: "Show both",
    
    displayName(mode) {
        // console.log(mode, 'mode');
        switch (mode) {
            case this.showName:
                return L10n.settingsDisplayModeName;
            case this.showAlternativeName:
                return L10n.settingsDisplayModeAltname;
            case this.showShortName:
                return L10n.settingsDisplayModeShortName;
            case this.showBoth:
                return L10n.settingsDisplayModeBoth;
            default:
                throw new Error("Invalid mode");
        }
    }
};



// Lines the till can print under the "** Category **" title on a kitchen category docket. Merchants
// disagree about what belongs there — some want only the table number, others the order number and
// the customer's phone — so each one is switchable.
//
// A missing key means "print it": merchants who have never opened this screen have no
// categoryHeaderFields map at all, and their dockets must not change.
const CategoryHeaderField = {
  TableNumber: "tableNumber",
  OrderNumber: "orderNumber",
  PagerNumber: "pagerNumber",
  StaffName: "staffName",
  GuestNumber: "guestNumber",
  SeatedGuestNumber: "seatedGuestNumber",
  CustomerName: "customerName",
  CustomerPhone: "customerPhone",
  CustomerPhoneOnDineIn: "customerPhoneOnDineIn",
  CustomerNotes: "customerNotes",
  DeliveryTime: "deliveryTime",
};

const CATEGORY_HEADER_FIELDS = [
  { key: CategoryHeaderField.TableNumber, label: "Table number" },
  { key: CategoryHeaderField.OrderNumber, label: "Order number" },
  { key: CategoryHeaderField.PagerNumber, label: "Pager number" },
  { key: CategoryHeaderField.StaffName, label: "Staff name" },
  {
    key: CategoryHeaderField.GuestNumber,
    label: "Number of guests",
    helperText: "Also needs Guest Number switched on in the till's own print settings.",
  },
  { key: CategoryHeaderField.SeatedGuestNumber, label: "Seated guest number" },
  { key: CategoryHeaderField.CustomerName, label: "Customer name" },
  { key: CategoryHeaderField.CustomerPhone, label: "Customer phone" },
  { key: CategoryHeaderField.CustomerNotes, label: "Customer notes" },
  { key: CategoryHeaderField.DeliveryTime, label: "Pickup / delivery time" },
];

// Every field defaults to on, except dine-in phone numbers, which stay off unless asked for.
const defaultCategoryHeaderFields = () => {
  const fields = { [CategoryHeaderField.CustomerPhoneOnDineIn]: false };
  CATEGORY_HEADER_FIELDS.forEach(({ key }) => {
    fields[key] = true;
  });
  return fields;
};

// Firestore rejects undefined, and a half-written map would read as "hide the missing lines" on the
// till. Always send a complete set of real booleans.
const resolveCategoryHeaderFields = (fields) => {
  const resolved = defaultCategoryHeaderFields();
  Object.keys(resolved).forEach((key) => {
    if (fields && fields[key] !== undefined) {
      resolved[key] = fields[key] !== false;
    }
  });
  return resolved;
};

export {
  OrderType,
  PrintType,
  OBNameDisplayMode,
  CategoryHeaderField,
  CATEGORY_HEADER_FIELDS,
  defaultCategoryHeaderFields,
  resolveCategoryHeaderFields,
};

